// extracted by mini-css-extract-plugin
export default {"nodata":"styles_nodata__WyVfm","main":"styles_main__EzKsL"};